import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { px2rem } from '../../helpers/style.js';
import { colors } from '../../../constants/colors.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var listItemsAttributesWeb = {
  color: 'primary',
  background: 'background',
  textColor: 'text',
  active: 'background.secondary',
  autocompleteText: {
    normal: 'text.secondary',
    hover: 'label.filled'
  },
  /**
   * Directly passed to white-space css rule for each item in the list
   */
  whiteSpace: 'nowrap',
  borders: {
    width: 2
  },
  header: {
    borderColor: colors.cloudGrey,
    borderWidth: 2
  },
  sizings: {
    xs: {
      height: 40,
      lineHeight: px2rem(36),
      fontSize: px2rem(16)
    },
    s: {
      height: 48,
      lineHeight: px2rem(44),
      fontSize: px2rem(16)
    },
    m: {
      height: 56,
      lineHeight: px2rem(52),
      fontSize: px2rem(18)
    },
    l: {
      height: 64,
      lineHeight: px2rem(60),
      fontSize: px2rem(18)
    }
  },
  boxShadow: 'none',
  fontSize: px2rem(18),
  paddingHorizontal: px2rem(16)
};
var listItemsThemeWeb = _objectSpread(_objectSpread({}, listItemsAttributesWeb), {}, {
  variants: {
    condensed: {
      fontSize: px2rem(16)
    }
  }
});

export { listItemsThemeWeb };
